import { idOf, keepExisting, setCookie } from '../../common/util.js';
import { SiteContext } from '../context.js';
import { Id, Maybe } from '../../common/data.js';
import { OwnUser, User } from '../../common/data/users.js';
import { Account, OwnAccount } from '../../common/data/accounts.js';
import { Cart } from '../../common/data/cart.js';

export interface ClientActiveEntities {
	user: Maybe<Id<User>>;
	account: Maybe<Id<Account>>;
	cart: Maybe<Id<Cart>>;
}
export interface ClientServiceMessage {
	activeEntities?: Maybe<ClientActiveEntities>;
}

export async function setUpServiceWorker(sc: SiteContext) {
	const [user, account, context] = [sc.user.peek(), sc.account.peek(), sc.context.peek()];
	if (('serviceWorker' in navigator) && user && account) {
		await navigator.serviceWorker.register(`/service!${context.resourceHashes['service.js']?.slice(0, 6)}.js`);
		await bumpServiceWorker(sc);
	}
}

export async function bumpServiceWorker(sc: SiteContext) {
	const [user, account, cart] = [sc.user.peek(), sc.account.peek(), sc.cart.peek()];
	if (('serviceWorker' in navigator) && user && account) {
		const reg = await navigator.serviceWorker.getRegistration();
		const msg: ClientServiceMessage = {
			activeEntities: {
				user: user.id,
				account: account.id,
				cart: cart?.id,
			},
		};
		for (const sw of keepExisting([reg?.active, reg?.installing])) sw.postMessage(msg);
	}
}

export async function setActiveAccount(sc: SiteContext, user: OwnUser, account: OwnAccount) {
	setCookie('account', idOf(account), 86400 * 90);
	sessionStorage.setItem('account', idOf(account));
	sc.user.value = user;
	sc.account.value = account;
	await bumpServiceWorker(sc);
}
